import { Menu, Button } from "@mantine/core";
import { BsThreeDotsVertical } from "react-icons/bs";
import { removeNote } from "../../services/note";
import { deleteTask } from "../../services/task";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteAttendanceStaff,
  getAllAttendenceStaff,
  updateAttendenceStaff,
} from "../../services/staff";
import { useSelector } from "react-redux";

function MenuDropdown({
  isNote,
  row,
  view,
  taskItem,
  isTask,
  isDashboradMode,
  startDate,
  endDate,
  isStaff,
  edit,
  disabled,
  isEdit = true,
  track,
  currentPage,
  range,
  isAttendance,
}) {
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state?.profile);

  const location = useLocation();

  const deleteNoteHandle = async (canDelete) => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });

    if (willDelete)
      removeNote(row, null, () => {}, null, null, isDashboradMode);
  };

  const deleteAttendanceHandle = async () => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) {
      const res = await deleteAttendanceStaff(track?._id);
      await getAllAttendenceStaff(currentPage, range);
    }
  };

  const deleteTaskHandle = async (taskId, shift) => {
    await deleteTask({ taskId, shift }, startDate, endDate);
  };

  const handleStaffManageAttendance = () => {
    navigate(`/home/staff/manage-attendance/${row?.id}`);
  };

  const Changestatus = async (status) => {
    try {
      let payload = [
        {
          id: track._id,
          approvedStatus: status,
        },
      ];

      let result = await updateAttendenceStaff(payload);

      await getAllAttendenceStaff(currentPage, range);
    } catch (error) {
    }
  };

  return (
    <div style={{ position: "relative", overflow: "visible" }}>
      <Menu shadow="md" width={160} withinPortal={true}>
        <Menu.Target>
          <Button variant="unstyled">
            <BsThreeDotsVertical />
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          {/* {isNote !== true && isEdit && ( */}
              {isNote !== true && profile?.user?.role !=='staff' && (
            <Menu.Item
              onClick={() => {
                if (isTask) {
                  navigate("/home/edit-task", {
                    state: { ...row, selectedShift: taskItem },
                  });
                } else {
                  edit();
                }
              }}
              disabled={disabled}
            >
              Edit
            </Menu.Item>
          )}

          {isNote !== true && isEdit && track && (
            <Menu.Item
              onClick={() =>
                Changestatus(
                  track?.approvedStatus === "approved" ? "pending" : "approved"
                )
              }
              disabled={disabled || track?.staff?.id === profile?.user?.admin}
            >
              {track?.approvedStatus === "approved"
                ? "Mark as pending"
                : "Mark as approved"}
            </Menu.Item>
          )}

          <Menu.Item
            onClick={() => {
              if (isTask) {
                navigate("/home/view-task", {
                  state: { ...row, selectedShift: taskItem },
                });
              } else {
                view();
              }
            }}
          >
            View
          </Menu.Item>

          {isStaff && (
            <Menu.Item
              onClick={() => {
                handleStaffManageAttendance();
              }}
            >
              Manage Attendance
            </Menu.Item>
          )}

          {!isStaff && profile?.user?.role !=='staff' && (
            <Menu.Item
              onClick={() => {
                if (isTask) {
                  deleteTaskHandle(row?.id, taskItem);
                } else if (isAttendance) {
                  deleteAttendanceHandle();
                } else {
                  deleteNoteHandle();
                }
              }}
            >
              Delete
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </div>
  );
}
export default MenuDropdown;
